import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/landing.css";
// LandingPage.js 맨 위 import들 사이에 추가
import CoupangAdBlock from "../components/common/CoupangAdBlock";

function LandingPage() {
  const navigate = useNavigate();

  const handleStart = () => {
    navigate("/test");
  };

  return (
    <div className="landing">
      <header className="landing-header">
        <div className="landing-logo">MMBBTTII</div>
        {/* <button
          type="button"
          className="landing-header-cta"
          onClick={handleStart}
        >
          테스트 시작
        </button> */}
      </header>

      <main className="landing-main">
        <div className="landing-pill-row">
          <span className="landing-pill">성향 분석 테스트</span>
          <span className="landing-pill landing-pill--sub">BETA</span>
        </div>

        <h1 className="landing-title">MMBBTTII</h1>

        <p className="landing-subtitle">
          MBTI 네 글자 대신, E / I / S / N / T / F / P / J
          <br />
          여덟 가지 성향을 각각 0~100으로 보는 테스트입니다.
        </p>
        {/* 진바키 느낌 삽화 블록 */}
        <section className="landing-illo">
          <div className="landing-illo-character">
            <div className="landing-illo-face" />
          </div>
          <div className="landing-illo-text">
            <p className="landing-illo-line">“아, 난 MBTI 안 믿는데…”</p>
            <p className="landing-illo-line landing-illo-line--accent">
              근데 이건 MBTI가 아니라 <strong>MMBBTTII</strong>인데?
            </p>
          </div>
        </section>
        {/* <div className="landing-traits">
          {["E", "I", "S", "N", "T", "F", "P", "J"].map((t) => (
            <span key={t} className="landing-trait-chip">
              {t}
            </span>
          ))}
        </div> */}

        <button
          className="landing-button landing-button--center-large"
          type="button"
          onClick={handleStart}
        >
          50문항 테스트 시작하기
        </button>

        <p className="landing-caption">
          약 7분 소요 · 결과는 바로 확인 가능합니다.
        </p>

        <div className="landing-feature-row">
          {/* <div className="landing-feature">
            <div className="landing-feature-title">8개 성향 점수화</div>
            <div className="landing-feature-desc">
              E/I/S/N/T/F/P/J 각각을 따로 계산해 <br />
              겹치는 성향까지 보여줍니다.
            </div>
          </div>
          <div className="landing-feature">
            <div className="landing-feature-title">MBTI 라벨 없음</div>
            <div className="landing-feature-desc">
              &quot;ENFP냐 INFJ냐&quot; 가 아니라,
              <br />
              지금의 나를 수치로 가볍게 확인합니다.
            </div>
          </div>
          <div className="landing-feature">
            <div className="landing-feature-title">가벼운 심리 스냅샷</div>
            <div className="landing-feature-desc">
              진단이나 처방이 아니라, <br /> 오늘의 나를 한 번 훑어보는
              용도입니다.
            </div>
          </div> */}
          <br />
          <br />
          <br />

          {/* 🔽 랜딩 하단 쿠팡 배너 */}
          <section className="landing-ad-section">
            <a
              href="https://link.coupang.com/a/c9Z22N"
              target="_blank"
              rel="noopener noreferrer"
              referrerPolicy="unsafe-url"
              className="coupang-banner-link"
            >
              <img
                src="https://ads-partners.coupang.com/banners/947370?subId=&traceId=V0-301-5f9bd61900e673c0-I947370&w=728&h=90"
                alt="쿠팡 배너"
                className="coupang-banner-img"
              />
            </a>
            <p className="coupang-ad-note">
              이 포스팅은 쿠팡 파트너스 활동의 일환으로, 이에 따른 일정액의
              수수료를 제공받습니다.
            </p>
          </section>
        </div>
      </main>

      <footer className="landing-footer">
        <div className="landing-footer-text">© 2025 mmbbttii</div>
        {/* <div className="landing-footer-sub">
          진짜 너를 찾으려면 MBTI를 벗어나라, 제발.
        </div> */}
      </footer>
    </div>
  );
}

export default LandingPage;
